import { Check } from 'lucide-react'
import {
	Button,
	Icon,
	Popover,
	PopoverContent,
	PopoverTrigger,
	Command,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
} from '#app/ui/components'

type CityFilterProps = {
	cities: string[]
	selectedCities: string[]
	onSelect: (cities: string[]) => void
	open: boolean
	onOpenChange: (open: boolean) => void
	searchValue: string
	onSearchChange: (value: string) => void
}

export function CityFilter({
	cities,
	selectedCities,
	onSelect,
	open,
	onOpenChange,
	searchValue,
	onSearchChange,
}: CityFilterProps) {
	return (
		<Popover open={open} onOpenChange={onOpenChange}>
			<PopoverTrigger asChild>
				<Button
					variant="outline"
					role="combobox"
					aria-expanded={open}
					className="flex-1"
				>
					<span className="truncate">
						{selectedCities.length > 0
							? selectedCities.length <= 3
								? selectedCities.join(`, `)
								: `${selectedCities.slice(0, 3).join(`, `)} +${selectedCities.length - 3}`
							: `All Cities`}
					</span>
					{selectedCities.length > 0 ? (
						<Icon
							name="cross-2"
							className="ml-2 h-4 w-4 shrink-0 cursor-pointer"
							onClick={(e) => {
								e.stopPropagation()
								onSelect([])
							}}
						/>
					) : (
						<Icon name="chevron-down" className="ml-2 h-4 w-4 shrink-0" />
					)}
				</Button>
			</PopoverTrigger>
			<PopoverContent
				side="bottom"
				align="start"
				onOpenAutoFocus={(e) => e.preventDefault()}
			>
				<Command shouldFilter={true}>
					<CommandInput
						placeholder="Search cities..."
						value={searchValue}
						onValueChange={onSearchChange}
						autoFocus
					/>
					<CommandList>
						<CommandEmpty>No city found.</CommandEmpty>
						<CommandGroup>
							<CommandItem
								value="all-cities"
								onSelect={() => {
									onSelect([])
									onOpenChange(false)
									onSearchChange(``)
								}}
							>
								<Check
									className={`mr-2 h-4 w-4 ${
										selectedCities.length === 0 ? `opacity-100` : `opacity-0`
									}`}
								/>
								All Cities
							</CommandItem>
							{cities.map((city) => (
								<CommandItem
									key={city}
									value={city}
									onSelect={(cityName) => {
										const newCities = selectedCities.includes(cityName)
											? selectedCities.filter((c) => c !== cityName)
											: [...selectedCities, cityName]
										onSelect(newCities)
										// Clear the search for quick multi-selection
										onSearchChange(``)
									}}
								>
									<Check
										className={`mr-2 h-4 w-4 ${
											selectedCities.includes(city) ? `opacity-100` : `opacity-0`
										}`}
									/>
									{city}
								</CommandItem>
							))}
						</CommandGroup>
					</CommandList>
				</Command>
			</PopoverContent>
		</Popover>
	)
}
